import controller from './home.controller';
import template from './home.html';
import './home.css';

const HealthcarebookHomeComponent = {
    bindings: {
    },
    controller,
    template,
};

export default HealthcarebookHomeComponent;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/home/home.component.js
// module id = 626
// module chunks = 0